import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    wrapPayment: {
        borderBottom: '1px solid rgba(0,0,0,.3)', 
        paddingBottom: 10
    },
    payment: {
        color: '#fff',
        fontSize: 14,
        fontFamily: 'PT-sans, sans-serif',
    },
    wrapBlock: {
        padding: '0 20px', display: 'flex', justifyContent: 'space-between', columnGap: 5, marginTop: 20, borderBottom: '1px solid rgba(0,0,0,.3)', paddingBottom: 10
    },
    w50: {
        width: '50%'
    },
    block: {
        display: 'flex', 
        alignItems: 'center', 
        flexDirection: 'column', 
        marginBottom: 8
    },
    helper: {
        color: 'hsla(0,0%,100%,.5)',
        fontSize: '14px',
        fontFamily: 'PT-sans, sans-serif',
        paddingBottom: 4
    }
}))

export {
    useStyles
}